import './LiveClass.scss';
import images from '../../assets/images';
import SubjectHeader from '../../components/SubjectHeader/SubjectHeader';
import NoLiveSessions from '../../components/NoLiveSessions/NoLiveSessions';
import CreateSchedule from '../../components/CreateSchedule/CreateSchedule';
import { GET_ALL_LIVE_SESSIONS, GET_ALL_SAVED_SESSIONS, GET_SESSTION_BY_ID, UPDATE_SESSION_PARTICIPANTS_COUNT, UPDATE_SESSION_STATUS } from './api/LiveClassQuery';
import { useLazyQuery, useMutation } from '@apollo/client';
import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { useAppSelector } from '../../redux/app/hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import SessionsList, { savedSessionType } from '../../components/SessionsListContainer/SessionsList';
import Loader from '../../components/Loader/Loader';
import ToasterWithMessage from '../../components/toaster';
import { createTheme, Dialog, styled, ThemeProvider } from '@mui/material';
import { FETCH_POLICY, FETCH_POLICY_NO_CACHE, JITSI, PATH_ADDRESSES, STUDENT_ROLE, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR, TEACHER_ROLE } from '../../utils/constants';
import { useDispatch } from 'react-redux';
import { setCurrentSessionDetail, setCurrentSessionId, setCurrentSessionTopic, setCurrentVideoData, setMeetComponentName, setCurrentSessionRecordingDetail, setCurrentUserId } from '../../redux/slices/dashboardSlice';
import { useGlobalState } from '../../MeetContext/MeetContext';
import { useChimeMeeting } from '../../Chime/ChimeMeetingContext';
import { getChimeParticipants } from '../../Chime/helpers/get-participants';
import { generateUniqueMeetingId, hasUserAlreadyJoined } from '../../utils/helper';
import { trackButtonClick } from '../../firebase/analyticsHelper';
import { ButtonClickEvents } from '../../firebase/constants/events';
import { captureEvent, updateUserProperties } from '../../utils/PostHogHelper';
import { ADD_SESSION_PARTICIPANTS, DELETE_SESSION_PARTICIPANT, UPDATE_LIVECLASS_HOST_ID, UPDATE_LIVECLASS_MEET_CHAT_STATUS, UPDATE_LIVECLASS_REPLICA_MEETING_IDS } from '../../Chime/helpers/Api/ChimeApi';
import { createChimeMeeting } from '../../Chime/helpers/create-meeting';
import { useMeetingManager } from 'amazon-chime-sdk-component-library-react';

export interface liveSessionListType{
  sessionId: string,
  startDate: string,
  endDate: string,
  savedSessionUrl: string | null,
  lessonTopic: string,
  isactive: boolean,
  isSessionStart:boolean
}
export interface singleSessionType{
  type?: "liveclass";
  sessionId: string;
  startdate: string;
  enddate: string;
  isActive: boolean;
  isSessionStart: boolean;
  lessonTopic: string;
  teachingPeriod:string;
  discussionPeriod:string;
  description:string;
  sessionCode:string;
  participantscount: number;
  hostId?: string;
  isRecordStart: boolean;
  recordStartTime: string| null;
  serverUrl?: string | null;
  botUrl?: string | null;
  meetingType?: string | null;
  participantIds: string[];
  replicaMeetingIds?: string[];
  showChat: boolean;
  originalHostId : string;
  mediaPipelineArn : string;
  mediaPipelineId : string;
}
export interface savedSessionListType{
  rsId: string;
  savedSessionUrl: string;
  recordSessionType: string;
  createdAt: string;
  sjId: string;
  sessionId: string;
  topic: string;
  videosPlaybacktimesByRsId: {
    nodes: [{
      playbackTime: string;
    }]
  }
  playbackTime?:string;
}
export interface getAllSavedSessionsType{
  nodes: savedSessionListType[],
  totalCount: number
}

const theme= createTheme({
  components: {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: "black",
        },
      },
    },
  }}
)

// Create a styled Dialog component
const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    display: 'block',
    maxWidth: '78%',
    maxHeight: '97%',
    overflow: 'hidden'
  },
}));

const LiveClass = () => {
    const {state} = useLocation();
    const {error} = ToasterWithMessage();
    const {localStream, setIsMeetingEndByHost} = useGlobalState();
    const {whiteCrossIcon, expandVideoIcon} = images;
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const [editClicked, setEditClicked] = useState<boolean>(false);
    const [isClickedSessionDetail,setIsClickedSessionDetail] = useState<boolean>(false);
    const [showCreateScheduling,setShowCreateScheduling] = useState<boolean>(false);
    const [singleSessionDetail,setSingleSessionDetail] = useState<singleSessionType>(); 
    const [savedSessionsList, setSavedSessionsList] = useState<getAllSavedSessionsType>();
    const [clickedVideoUrl,setClickedVideoUrl] = useState<string>('');
    const [clickedExpandView, setClickedExpandView] = useState<boolean>(false);
    const [clickedSessionDetails,setClickedSessionDetails] = useState<singleSessionType>();
    const [liveSessionsList,setLiveSessionsList] = useState<liveSessionListType[]>([]);
    const [isDeleted,setIsDeleted] = useState<boolean>(false);
    const [totalCount,setTotalCount] = useState<number>();
    const role = useAppSelector((state) => state.auth.role);
    const loginpage = useAppSelector((state) => state.auth.loginpage);
    const meetService = useAppSelector((state) => state.auth.meetService);
    const navigate = useNavigate();
    const [clickedVideoData, setClickedVideoData] = useState<savedSessionType | null>(null);
    const [isUpdateVideoTime, setIsUpdateVideoTime] = useState<boolean>(false);
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const profile = useAppSelector((state) => state?.auth?.adminProfile);
    const [isTeacherButtonClicked, setIsTeacherButtonClicked] = useState<boolean>(false);
    const [isMoreClick,SetIsMoreClick] = useState<boolean>(false);
    const [sessionEnded, setSessionEnded] = useState<boolean>(false);
    const [isStudentButtonClicked, setIsStudentButtonClicked] = useState<boolean>(false);
    // const clickedVideoRefValue = useAppSelector((state) => state.dashboard.clickedVideoData);
    const mediaServerEnv = process.env.REACT_APP_MEDIA_SERVER_ENV;
    const { createMeeting, joinMeeting, setIsRecording, setRecordingStartTime, showChat, setShowChat, setHostId, setHostAttendeeId, setMediaPipelineArn, setMediaPipelineId } = useChimeMeeting();
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const streamRef = useRef<any>(null);
    const [alreadyTwoUsersSameId, setAlreadyTwoUsersSameId] = useState<boolean>(false)
    const currentUserId = profile?.getCurrentUser?.nodes?.[0]?.uId;
    const { currentSessionId, meetComponent } = useAppSelector((state) => state?.dashboard);
    const [isStartingMeeting, setIsStartingMeeting] = useState(false);
    const meetingManager = useMeetingManager();
    const REPLICA_THRESHOLD = parseInt(process.env.REACT_APP_REPLICA_THRESHOLD ?? "240");
    const dispatch = useDispatch();

    const [ getAllLiveSessions, {loading} ] = useLazyQuery(  GET_ALL_LIVE_SESSIONS, {
      fetchPolicy: FETCH_POLICY,
      onCompleted: (data) => {
       setTotalCount(data?.getLiveClassSessions?.totalCount);
       setLiveSessionsList(data?.getLiveClassSessions?.nodes);
       setClickedSessionDetails(undefined);
       setIsClickedSessionDetail(false);
       setIsDeleted(false);
      },
      onError: (err) => {
        error(err?.message);
        if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
          setTimeout(() => {
            if (role === STUDENT_ROLE) {
              navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
            } else {
              navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
            }
          }, 2000);
        }
      }
    });


 // Mutation to update liveclass host id and original host id
  const [updateLiveClassReplicaIds] = useMutation(UPDATE_LIVECLASS_REPLICA_MEETING_IDS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
          console.log("Liveclass host id updated successfully", data);
        },
        onError: (err) => {
            setIsStartingMeeting(false);
            error(err?.message);
        }
    }); 

  // Mutation to update liveclass host id and original host id
  const [updateHostIdForLiveclass] = useMutation(UPDATE_LIVECLASS_HOST_ID, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
          console.log("Liveclass host id updated successfully", data);
        },
        onError: (err) => {
            setIsStartingMeeting(false);
            error(err?.message);
        }
    }); 
    
 // Mutation to update liveclass chat status
  const [updateChatStatusForLiveclass] = useMutation(UPDATE_LIVECLASS_MEET_CHAT_STATUS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
          console.log("Liveclass host id updated successfully", data);
        },
        onError: (err) => {
            setIsStartingMeeting(false);
            error(err?.message);
        }
    });    

  
    
const [updateSessionParticipantCount] = useMutation(UPDATE_SESSION_PARTICIPANTS_COUNT, {
  fetchPolicy: FETCH_POLICY_NO_CACHE,
  onCompleted: (data) => {},
  onError: (err) => {
    setIsStartingMeeting(false);
  }
});

const [updateSessionStatus] = useMutation(UPDATE_SESSION_STATUS, {
  fetchPolicy: FETCH_POLICY_NO_CACHE,
  onCompleted: (data) => {
      fetchSessionDetails();
  },
  onError: (err) => {
    setIsTeacherButtonClicked(false);
    setIsStartingMeeting(false);
  }
});

const fetchSessionDetails = () => {
  if (singleSessionDetail) {
    getSingleSession({
      variables: {
        input: {
          cId: selectedClassRoomId,
          sjId: selectedSubjectId,
          sId: singleSessionDetail.sessionId
        }
      }
    });
  }
};

const [getSingleSession] = useLazyQuery(GET_SESSTION_BY_ID, {
  fetchPolicy: FETCH_POLICY_NO_CACHE,
  onCompleted: async (data) => {
    const response = data?.getSession || {};
    const meetId = response?.sessionCode;

    if (meetId && meetService !== JITSI) {
      getChimeParticipants(meetId)
        .then((participantsResponse) => {
          response.participantscount = participantsResponse?.Attendees ? participantsResponse?.Attendees?.length : 0;
        })
        .catch(() => {
          response.participantscount = 0;
        })
        .finally(() => {
          console.log("[Log] Participants count:", response.participantscount);
          if (isMoreClick === false) {
            setSingleSessionDetail(response);
          } else {
            setClickedSessionDetails({ ...response, type: "liveclass" });
          }
        });
    } else {
      if (isMoreClick === false) {
        setSingleSessionDetail(response);
      } else {
        setClickedSessionDetails({ ...response, type: "liveclass" });
      }
    }
    setSessionEnded(false);
  },
  onError: (err) => {
    if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
      error(err?.message);
      setTimeout(() => {
        if(role === STUDENT_ROLE){
          navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
       }else{
          navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
       }
      }, 2000);
    } else if(err?.message === "Session has ended"){
       setSessionEnded(true);
       setTimeout(() => {
        setSingleSessionDetail(undefined);
        fetchUpcomingSessions();
      }, 5000); 
    }else {
      error(err?.message)
    }
    setIsStartingMeeting(false);
  }
});


  const handleStartMeeting = async (stream?: any) => {
    trackButtonClick(ButtonClickEvents?.START_MEETING, {
        description : "User clicked start meeting button",
        page: 'Liveclass'
    });
    
    console.log("inside start meeting");
    dispatch(setCurrentUserId({ currentUserId: currentUserId || '' }));
    dispatch(setMeetComponentName({ meetComponent: 'liveclass' }));
    if (meetService === JITSI) {
      // Check for Jitsi server url
      if (!singleSessionDetail?.serverUrl) {
        error("Meeting Server setup in progress.");
        setIsTeacherButtonClicked(false);
        return;
      }
      
      const userId = profile?.getCurrentUser?.nodes?.[0]?.uId;
      const userName = profile?.getCurrentUser?.nodes[0]?.uFullName;
      const meetingId = generateUniqueMeetingId();
      console.log("meeting id is", meetingId);
      try {
        if (meetingId) {
          // updateSessionStatus({
          //   variables: {
          //     cId: selectedClassRoomId,
          //     sjId: selectedSubjectId,
          //     sId: singleSessionDetail?.sessionId,
          //     sCode: meetingId,
          //     hostId: userId,
          //   }
          // });
          if (singleSessionDetail?.sessionId) {
            dispatch(setCurrentSessionId({ currentSessionId: singleSessionDetail?.sessionId }));
            dispatch(setCurrentSessionDetail({ startDate: singleSessionDetail?.startdate, endDate: singleSessionDetail?.enddate, mediaPipelineArn : singleSessionDetail?.mediaPipelineArn ?? null , mediaPipelineId : singleSessionDetail?.mediaPipelineId ?? null }));
            dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: singleSessionDetail?.recordStartTime, recordingStarted: singleSessionDetail?.isRecordStart }));
            dispatch(setCurrentSessionTopic({ currentSessionTopic: singleSessionDetail?.lessonTopic }));
          }
          if(userId) {
                updateUserProperties({
                    meetingId: meetingId,
                });
                captureEvent(userId, {
                    role: role,
                    loginType: loginpage, // your redux login type
                    meetingId: meetingId,
                });
          }
          const existingState = state; // coming from useLocation() or props

          const newState = {
              ...existingState,                // ✅ spread existing values
              meetingId,
              userName,
              isHost: true,
              isCreateMeeting: true,
              hostId: userId,
              userId,
              meetComponent: 'liveclass',
              jitsiUrls: {
                    jitsiMeetUrl: singleSessionDetail?.serverUrl,
                    jitsiBotUrl: singleSessionDetail?.botUrl
                  }
              };

                // Save to storage
                localStorage.setItem("meetingState", JSON.stringify(newState));
                localStorage.setItem("isJoined", "joined");

                // Open in new tab
                if(window?.electron && window?.electron?.isElectron()){
                    window?.electron?.openMeetingWindow(`teacher-classroom/liveclass/meeting?meetId=${meetingId}`, newState);
                } else {
                    window.open(`/teacher-classroom/liveclass/meeting?meetId=${meetingId}`, "_blank");
                }

          // navigate(`/teacher-classroom/liveclass/meeting?meetId=${meetingId}`, { state: { ...state, meetingId, userName, isHost: true, isCreateMeeting: true, hostId: userId, userId, meetComponent: 'liveclass', jitsiUrls: { jitsiMeetUrl: singleSessionDetail?.serverUrl, jitsiBotUrl: singleSessionDetail?.botUrl } } });
        }
      } catch (err) {
        console.log("Creating Meeting Error :", error);
        localStorage.setItem("isJoined", "left");
        setIsTeacherButtonClicked(false);
      }
    }
    else {
      const userId = profile?.getCurrentUser?.nodes?.[0]?.uId;
      await createMeeting(userId).then(async (response) => {
        console.log('[Log] createMeeting response', response);
        const meetId = response?.Meeting?.MeetingId;
        // const data = await response.json();
        if (meetId) {
          // const {meetId, user, host, createdAt} = data.meetInfo;
          try {
            //await InitialiseMeeting({
            //   meetId,
            //   avatar: getRandomColor(),
            //   currentUser: {
            //       userId: user.userId,
            //       avatarKey: user.avatarKey,
            //       userKey: user.userKey,
            //       userName: user.userName,
            //       preference: {
            //           audio: true,
            //           video: true,
            //           screen: false,
            //           hand: false
            //       },
            //       isPinned: {video: false, screen: false}
            //   },
            //   host:{
            //       hostId: host.hostId,
            //       hostKey: host.hostKey,
            //       hostName: host.hostName
            //   },
            //   createdAt
            // }, FormType.CREATE);
            // await updateSessionParticipantCount({
            //   variables: {
            //     cId: selectedClassRoomId,
            //     sId: singleSessionDetail?.sessionId,
            //     sjId: selectedSubjectId,
            //     participanttype: true
            //   }
            // })
          } catch (err) {
            setIsTeacherButtonClicked(false);
            setIsStartingMeeting(false);
          }

          const participants = await getChimeParticipants(meetId);
          let hostAttendee:any = null;
          // Find the host attendee
          if(participants?.Attendees){
              hostAttendee =  participants.Attendees.find(
                 (attendee) => attendee.ExternalUserId === userId
              );
          }

          console.log("Host AttendeeId while creating:", hostAttendee?.AttendeeId);
          localStorage.setItem("hostId", userId ?? "");
          localStorage.setItem("hostAttendeeId", hostAttendee?.AttendeeId ?? "");
          setHostAttendeeId(hostAttendee?.AttendeeId || ''); 
          await updateSessionStatus({
            variables: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              sId: singleSessionDetail?.sessionId,
              sCode: meetId,
              hostId: userId,
            }
          });

          await updateHostIdForLiveclass({
            variables: {
              input: {
                  pCId: selectedClassRoomId,
                  pSubjectId: selectedSubjectId,
                  pSessionId: singleSessionDetail?.sessionId,
                  pHostId: userId,
                  pUpdateOriginal: true
                }
            }
          });

          await updateChatStatusForLiveclass({
            variables: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              sessionId: singleSessionDetail?.sessionId,
              showChat: !(singleSessionDetail?.isSessionStart) ? showChat : singleSessionDetail?.showChat
            }
          });

          if (singleSessionDetail?.sessionId) {
            if (singleSessionDetail?.isSessionStart) {
                setShowChat(singleSessionDetail?.showChat);
            }
            dispatch(setCurrentSessionId({ currentSessionId: singleSessionDetail?.sessionId }));
            dispatch(setCurrentSessionDetail({ startDate: singleSessionDetail?.startdate, endDate: singleSessionDetail?.enddate, mediaPipelineArn : singleSessionDetail?.mediaPipelineArn ?? null , mediaPipelineId : singleSessionDetail?.mediaPipelineId ?? null  }));
            dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: singleSessionDetail?.recordStartTime, recordingStarted: singleSessionDetail?.isRecordStart }));
            dispatch(setCurrentSessionTopic({ currentSessionTopic: singleSessionDetail?.lessonTopic }));
          }
          if(userId) {
                updateUserProperties({
                    meetingId: meetId,
                });
                captureEvent(userId, {
                    role: role,
                    loginType: loginpage, // your redux login type
                    meetingId: meetId,
                });
          }   
          navigate(`/teacher-classroom/liveclass/meeting?meetId=${meetId}`, { state: { ...state, sessionId: singleSessionDetail?.sessionId }});
        }
      }).catch((error) => {
        console.log("Creating Meeting Error :", error);
        setIsStartingMeeting(false);
        setIsTeacherButtonClicked(false);
        stream.getAudioTracks()[0].stop();
        stream.getVideoTracks()[0].stop();
      });
    }
  };

 const handleJoinMeeting = async (stream?: MediaStream) => {
  trackButtonClick(ButtonClickEvents?.JOIN_MEETING, {
      description : "User clicked join meeting button",
      page: 'Liveclass'
  });

  streamRef.current = stream;

  try {
    const { data } = await getSingleSession({
      variables: {
        input: {
          cId: selectedClassRoomId,
          sjId: selectedSubjectId,
          sId: singleSessionDetail?.sessionId,
        },
      },
      fetchPolicy: FETCH_POLICY_NO_CACHE,
    });

    const response = data?.getSession;
    if (!response) {
      return;
    }

    const alreadyJoined = hasUserAlreadyJoined(response.participantIds || [], currentUserId);
    setAlreadyTwoUsersSameId(alreadyJoined);

    if (alreadyJoined) {
      console.log("User already joined, blocking...");
      return; 
    }

    console.log("User not joined, proceeding...");
    await handleJoinAfterApi(stream); 

  } catch (err) {
    console.error("Error fetching session:", err);
  }
};




const handleJoinAfterApi = async(stream? : MediaStream) =>{
   dispatch(setCurrentUserId({ currentUserId: currentUserId || '' }));
   dispatch(setMeetComponentName({ meetComponent: 'liveclass' }));
    if (meetService === JITSI) {
      // Check for Jitsi server url
      if (!singleSessionDetail?.serverUrl) {
        error("Meeting Server setup in progress.");
        if (role === TEACHER_ROLE) {
          setIsTeacherButtonClicked(false);
        } else if (role === STUDENT_ROLE) {
          setIsStudentButtonClicked(false);
        }
        return;
      }
      
      const userId = profile?.getCurrentUser?.nodes?.[0]?.uId;
      const userName = profile?.getCurrentUser?.nodes[0]?.uFullName;

      if (singleSessionDetail?.sessionCode && singleSessionDetail?.hostId) {
        try {
          if (singleSessionDetail?.sessionId) {
            dispatch(setCurrentSessionId({ currentSessionId: singleSessionDetail?.sessionId }));
            dispatch(setCurrentSessionDetail({ startDate: singleSessionDetail?.startdate, endDate: singleSessionDetail?.enddate, mediaPipelineArn : singleSessionDetail?.mediaPipelineArn ?? null , mediaPipelineId : singleSessionDetail?.mediaPipelineId ?? null }));
            dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: singleSessionDetail?.recordStartTime, recordingStarted: singleSessionDetail?.isRecordStart }));
            setRecordingStartTime(singleSessionDetail?.recordStartTime);
            setIsRecording(singleSessionDetail?.isRecordStart);
            dispatch(setCurrentSessionTopic({ currentSessionTopic: singleSessionDetail?.lessonTopic }));
          }
          if(userId) {
                    updateUserProperties({
                         meetingId: singleSessionDetail?.sessionCode, // overwrite old value
                    });
                    captureEvent(userId, {
                        role: role,
                        loginType: loginpage, // your redux login type
                        meetingId: singleSessionDetail?.sessionCode,
                    });
                }

          const existingState = state; // coming from useLocation() or props          
          if (role === STUDENT_ROLE) {
              const newState = {
                ...existingState,   
                meetingId: singleSessionDetail?.sessionCode, 
                userName: userName, 
                isHost: false, 
                isCreateMeeting: false, 
                hostId: singleSessionDetail?.hostId, 
                userId, 
                meetComponent: 'liveclass', 
                jitsiUrls: { 
                    jitsiMeetUrl: singleSessionDetail?.serverUrl, 
                    jitsiBotUrl: singleSessionDetail?.botUrl 
                }
                };

                // Save to storage
                localStorage.setItem("meetingState", JSON.stringify(newState));
                localStorage.setItem("isJoined", "joined");

                if(window?.electron && window?.electron?.isElectron()){
                    window?.electron?.openMeetingWindow(`student-classroom/liveclass/meeting?meetId=${singleSessionDetail?.sessionCode}`, newState);
                } else {
                   window.open(`/student-classroom/liveclass/meeting?meetId=${singleSessionDetail?.sessionCode}`, "_blank");
                }            
            // navigate(`/student-classroom/liveclass/meeting?meetId=${singleSessionDetail?.sessionCode}`, { state: { ...state, meetingId: singleSessionDetail?.sessionCode, userName: userName, isHost: false, isCreateMeeting: false, hostId: singleSessionDetail?.hostId, userId, meetComponent: 'liveclass', jitsiUrls: { jitsiMeetUrl: singleSessionDetail?.serverUrl, jitsiBotUrl: singleSessionDetail?.botUrl } } });
          } else if (role === TEACHER_ROLE) {
              const newState = {
                ...existingState,   
                meetingId: singleSessionDetail?.sessionCode, 
                userName: userName, 
                isHost: singleSessionDetail?.hostId && userId === singleSessionDetail.hostId, 
                isCreateMeeting: false, 
                hostId: singleSessionDetail?.hostId, 
                userId, 
                meetComponent: 'liveclass', 
                jitsiUrls: { 
                    jitsiMeetUrl: singleSessionDetail?.serverUrl, 
                    jitsiBotUrl: singleSessionDetail?.botUrl 
                }
                };

                // Save to storage
                localStorage.setItem("meetingState", JSON.stringify(newState));
                localStorage.setItem("isJoined", "joined");

                if(window?.electron && window?.electron?.isElectron()){
                    window?.electron?.openMeetingWindow(`teacher-classroom/liveclass/meeting?meetId=${singleSessionDetail?.sessionCode}`, newState);
                } else {
                   window.open(`/teacher-classroom/liveclass/meeting?meetId=${singleSessionDetail?.sessionCode}`, "_blank");
                }            
            // navigate(`/teacher-classroom/liveclass/meeting?meetId=${singleSessionDetail?.sessionCode}`, { state: { ...state, meetingId: singleSessionDetail?.sessionCode, userName: userName, isHost: singleSessionDetail?.hostId && userId === singleSessionDetail.hostId, isCreateMeeting: false, hostId: singleSessionDetail?.hostId, userId, meetComponent: 'liveclass', jitsiUrls: { jitsiMeetUrl: singleSessionDetail?.serverUrl, jitsiBotUrl: singleSessionDetail?.botUrl } } });
          }
        } catch (err) {
          localStorage.setItem("isJoined", "left");
          if (role === TEACHER_ROLE) {
            setIsTeacherButtonClicked(false);
          } else if (role === STUDENT_ROLE) {
            setIsStudentButtonClicked(false);
          }
        }
      }
    }
    else {
      const userId = profile?.getCurrentUser?.nodes?.[0]?.uId;
      if (singleSessionDetail?.sessionCode && singleSessionDetail?.hostId) {
        let primaryMeetingId = singleSessionDetail?.sessionCode;
        const replicaMeetingIds: string[] = singleSessionDetail?.replicaMeetingIds || [];

        // Combine the primary meeting and any replica meetings into one list
        const allMeetingIds = [primaryMeetingId, ...replicaMeetingIds];
        console.log("All Meeting Ids:", allMeetingIds);

        // Fetch participant counts for all meeting IDs in parallel
        const meetingCountsPromises = allMeetingIds.map(async (id) => {
            const response = await getChimeParticipants(id);
            const count = response?.Attendees ? response?.Attendees?.length : 0;
            return { id, count };
        });
        const meetingCounts = await Promise.all(meetingCountsPromises);
        console.log("Meeting Counts:", meetingCounts);

        // Decide which meeting instance to join: choose the first meeting that isn't full.
        let chosenMeetingId: string | null = null;
        for (const { id, count } of meetingCounts) {
            if (count < REPLICA_THRESHOLD) {
              chosenMeetingId = id;
              break;
            }
        }

        // If all existing meeting instances are full, create a new replica meeting.
        if (!chosenMeetingId) {
          const replicaMeetingResponse = await createChimeMeeting(
            singleSessionDetail?.sessionCode
          );
          const newReplicaMeetingId =
            replicaMeetingResponse?.Meeting?.MeetingId;
          if (newReplicaMeetingId) {
            // Update the replica meetings array by appending the new meeting ID.
            const updatedReplicaMeetingIds = [
              ...replicaMeetingIds,
              newReplicaMeetingId,
            ];
            await updateLiveClassReplicaIds({
              variables: {
                cId: selectedClassRoomId,
                sjId: selectedSubjectId,
                sessionId: singleSessionDetail?.sessionId,
                replicaMeetingIds: updatedReplicaMeetingIds
              }
            })
            chosenMeetingId = newReplicaMeetingId;
          }
        }

        // Fallback: if still no meeting is chosen, default to primary meeting
        const finalMeetingId = chosenMeetingId || primaryMeetingId;        
        const originalHostId =  singleSessionDetail.originalHostId
        let hostAttendee: any = null;
        let hostExternalUserId: any = "";

        // Assume you already have these
        await getChimeParticipants(finalMeetingId)
          .then((participants) => {
            console.log("[Log] Participants List:", participants);
            console.log(
              "userId",
              userId,
              "singleSessionDetail.hostId",
              singleSessionDetail.hostId,
              "originalHostId",
              originalHostId
            );
            if (userId === originalHostId) {
              hostExternalUserId = userId;
            } else {
              hostExternalUserId = singleSessionDetail.hostId;
            }
            // Find the host attendee
            if (participants?.Attendees) {
              console.log("by using this hostExternalUserId", hostExternalUserId);
              hostAttendee = participants.Attendees.find((attendee: any) => {
                console.log("Checking attendee:", attendee.ExternalUserId);
                return attendee.ExternalUserId === hostExternalUserId;
              });
            }
          })
          .catch((error) => {
            console.error("Failed to fetch participants:", error);
          });

        if (hostAttendee) {
          console.log("Host AttendeeId:", hostAttendee.AttendeeId);
        } else {
          console.log("Host not found in the participants list");
        }        

        await joinMeeting(
          finalMeetingId,
          originalHostId === userId
            ? userId
            : singleSessionDetail.hostId === userId
            ? singleSessionDetail.hostId
            : `${userId}|${Date.now()}`,
          singleSessionDetail.hostId,
          originalHostId,
          hostAttendee?.AttendeeId || ''
        )
          .then(async (response) => {
            console.log("[Log] joinMeeting response", response);
            const meetId = response?.meetingResponse?.Meeting?.MeetingId;
            // const data = await response.json();
            if (meetId) {
              // const {meetId, user, host, createdAt} = data.meetInfo;
              if (userId === originalHostId) {
                await getChimeParticipants(meetId)
                  .then((participantsResponse) => {
                    console.log(
                      "userId",
                      userId,
                      "singleSessionDetail.hostId",
                      singleSessionDetail.hostId,
                      "originalHostId",
                      originalHostId
                    );
                    hostExternalUserId = userId;
                    // Find the host attendee
                    if (participantsResponse?.Attendees) {
                      hostAttendee = participantsResponse.Attendees.find((attendee: any) => {
                        console.log("Checking attendee:", attendee.ExternalUserId);
                        return attendee.ExternalUserId === hostExternalUserId;
                      });
                      console.log(
                        "Host AttendeeId after joining:",
                        hostAttendee?.AttendeeId || ""
                      );
                      setHostAttendeeId(hostAttendee?.AttendeeId || "");
                      console.log(
                        singleSessionDetail.mediaPipelineArn,
                        singleSessionDetail.mediaPipelineId,
                        "mediapipeline",
                        originalHostId
                      );
                      localStorage.setItem("hostId", userId ?? "");
                      localStorage.setItem("hostAttendeeId", hostAttendee?.AttendeeId ?? "");
                    }
                  })
                  .catch((error) => {
                    console.error("Failed to fetch participants:", error);
                  });

                console.log(userId, originalHostId, "originalHost");
                setHostId(userId);
                console.log(
                  singleSessionDetail.mediaPipelineArn,
                  singleSessionDetail.mediaPipelineId,
                  "mediapipeline",
                  originalHostId
                );

                setMediaPipelineArn(singleSessionDetail.mediaPipelineArn);
                setMediaPipelineId(singleSessionDetail.mediaPipelineId);
                meetingManager.audioVideo?.addObserver({
                  audioVideoDidStart: () => {
                    console.log("[Log] audioVideoDidStart - Sending realtime message");
                    try {
                      const message = {
                        action: "host-changed",
                        hostId: userId,
                        hostAttendeeId: hostAttendee?.AttendeeId || "",
                        ...(singleSessionDetail.mediaPipelineId && {
                          mediaPipelineId: singleSessionDetail.mediaPipelineId,
                        }),
                        ...(singleSessionDetail.mediaPipelineArn && {
                          mediaPipelineArn: singleSessionDetail.mediaPipelineArn,
                        }),
                      };

                      meetingManager.meetingSession?.audioVideo?.realtimeSendDataMessage(
                        "live-update",
                        JSON.stringify(message)
                      );
                    } catch (error) {
                      console.error("Failed to send realtime message:", error);
                    }
                  },
                });
                await updateHostIdForLiveclass({
                  variables: {
                    input: {
                      pCId: selectedClassRoomId,
                      pSubjectId: selectedSubjectId,
                      pSessionId: singleSessionDetail?.sessionId,
                      pHostId: userId,
                      pUpdateOriginal: false,
                    },
                  },
                });
              }              
              try {
                //   await InitialiseMeeting({
                //     meetId,
                //     avatar: getRandomColor(),
                //     currentUser: {
                //         userId: user.userId,
                //         userKey: user.userKey,
                //         userName: user.userName,
                //         avatarKey: user.avatarKey,
                //         preference: {
                //             audio: true,
                //             video: true,
                //             screen: false,
                //             hand: false
                //         },
                //         isPinned: {video: false, screen: false}
                //     },
                //     host:{
                //         hostId: host.hostId,
                //         hostKey: host.hostKey,
                //         hostName: host.hostName
                //     },
                //     createdAt
                // }, FormType.JOIN);
                // await updateSessionParticipantCount({
                //   variables: {
                //     cId: selectedClassRoomId,
                //     sId: singleSessionDetail?.sessionId,
                //     sjId: selectedSubjectId,
                //     participanttype: true
                //   }
                // })
              } catch (err) {
                setIsStartingMeeting(false);
                if (role === TEACHER_ROLE) {
                  setIsTeacherButtonClicked(false);
                } else if (role === STUDENT_ROLE) {
                  setIsStudentButtonClicked(false);
                }
              }
              if (singleSessionDetail?.sessionId) {
                setShowChat(singleSessionDetail?.showChat);
                dispatch(
                  setCurrentSessionId({
                    currentSessionId: singleSessionDetail?.sessionId,
                  })
                );
                dispatch(
                  setCurrentSessionDetail({
                    startDate: singleSessionDetail?.startdate,
                    endDate: singleSessionDetail?.enddate,
                    mediaPipelineArn : singleSessionDetail?.mediaPipelineArn ?? null, 
                    mediaPipelineId : singleSessionDetail?.mediaPipelineId ?? null
                  })
                );
                dispatch(
                  setCurrentSessionRecordingDetail({
                    recordingStartedTime: singleSessionDetail?.recordStartTime,
                    recordingStarted: singleSessionDetail?.isRecordStart,
                  })
                );
                setRecordingStartTime(singleSessionDetail?.recordStartTime);
                setIsRecording(singleSessionDetail?.isRecordStart);
                dispatch(
                  setCurrentSessionTopic({
                    currentSessionTopic: singleSessionDetail?.lessonTopic,
                  })
                );
                setShowChat(singleSessionDetail?.showChat);
              }
              if (userId) {
                updateUserProperties({
                  meetingId: meetId, // overwrite old value
                });
                captureEvent(userId, {
                  role: role,
                  loginType: loginpage, // your redux login type
                  meetingId: meetId,
                });
              }
              if (role === STUDENT_ROLE) {
                navigate(
                  `/student-classroom/liveclass/meeting?meetId=${meetId}`,
                  {
                    state: {
                      ...state,
                      sessionId: singleSessionDetail?.sessionId,
                    },
                  }
                );
              } else if (role === TEACHER_ROLE) {
                navigate(
                  `/teacher-classroom/liveclass/meeting?meetId=${meetId}`,
                  {
                    state: {
                      ...state,
                      sessionId: singleSessionDetail?.sessionId,
                    },
                  }
                );
              }
            }
          })
          .catch(() => {
            setIsStartingMeeting(false);
            if (role === TEACHER_ROLE) {
              setIsTeacherButtonClicked(false);
            } else if (role === STUDENT_ROLE) {
              setIsStudentButtonClicked(false);
            }
            stream?.getAudioTracks()[0].stop();
            stream?.getVideoTracks()[0].stop();
          });
      }
    }
  }


  //   const [updatePlayBackTimeForLiveClass] = useMutation(UPDATE_PLAY_TIME_FOR_VIDEO, {
  //     fetchPolicy: "no-cache",
  //     onCompleted: (data) => {
  //         setIsUpdateVideoTime(true);
  //         dispatch(setCurrentVideoData({
  //             videoCurrentTime: 0,
  //             videoId: ''
  //         }));
  //     },
  //     onError: (err) => {
  //         error(err?.message);
  //     }
  // });


//Once get the recorded session videos details, enable it and check it


// useEffect(() => {
//     if(clickedVideoData && clickedVideoUrl && clickedVideoRefValue?.videoCurrentTime){
//       console.log("clickedVideoRefValue?.videoCurrentTime.toString()", clickedVideoRefValue?.videoCurrentTime.toString())
//       updatePlayBackTimeForLiveClass({
//             variables: {
//               cId: selectedClassRoomId,
//               sePlayBackTime: clickedVideoRefValue?.videoCurrentTime.toString(),
//               sId: clickedVideoData?.sessionId,
//               sjId: selectedSubjectId 
//             }
//         })
//     }
// },[clickedVideoRefValue]);


useEffect(() => {

    if(clickedVideoData?.videosPlaybacktimesByRsId?.nodes?.[0]?.playbackTime && videoRef.current){
        videoRef.current.currentTime = parseFloat(clickedVideoData?.videosPlaybacktimesByRsId?.nodes?.[0]?.playbackTime);
    }
},[clickedVideoData]);


const handleOnMouseOut = () => {
    if(videoRef.current){
      dispatch(setCurrentVideoData({
        videoCurrentTime: videoRef.current.currentTime,
        videoId: clickedVideoData?.sessionId ? clickedVideoData?.sessionId : ''
      }))
    }
}


    const [ getAllSavedSessions, {loading: savedSessionLoading} ] = useLazyQuery(  GET_ALL_SAVED_SESSIONS, {
      fetchPolicy: FETCH_POLICY,
      onCompleted: (data) => {
        setSavedSessionsList(data?.allRecordedSessions);
        setIsUpdateVideoTime(false);
      },
      onError: (err) => {
        error(err?.message);
        if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
          setTimeout(() => {
            if (role === STUDENT_ROLE) {
              navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
            } else {
              navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
            }
          }, 2000);
        }
      }
    });

    const [deleteSessionParticipant] = useMutation(DELETE_SESSION_PARTICIPANT, {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onCompleted: (data) => {
        console.log("Participant deleted successfully:", data);
      },
      onError: (err) => {
        console.log(err)
      },
    });

  const onClickExpandIcon = () => {
      setClickedExpandView(true);
  }

  const onClickCloseIcon = () => {
    setClickedVideoUrl('');
    setClickedVideoData(null);
    setClickedExpandView(false);
  }

  const fetchUpcomingSessions = () => {
    const currentDateUTC = dayjs().utc().format();

    getAllLiveSessions({
      variables: {
        cId: selectedClassRoomId,
        sjId: selectedSubjectId,
        startDate: currentDateUTC
      }
    });
  }

  useEffect(() => {
    if(!isClickedSessionDetail){
      fetchUpcomingSessions();
    }
  },[isClickedSessionDetail, setIsClickedSessionDetail]);

  useEffect(() => {
    if (!showCreateScheduling || isDeleted || isUpdateVideoTime) {

      fetchUpcomingSessions();

      getAllSavedSessions({
        variables: {
          cId: selectedClassRoomId,
          sjId: selectedSubjectId
        }
      })
    }
  }, [showCreateScheduling, isDeleted, isUpdateVideoTime]);

  useEffect(() => {
    setIsMeetingEndByHost(false);
    localStorage.removeItem("hostId");
    localStorage.removeItem("hostAttendeeId");
    dispatch(setCurrentSessionDetail({startDate: null, endDate: null, mediaPipelineArn: null, mediaPipelineId: null}));
    dispatch(setCurrentSessionRecordingDetail({recordingStartedTime: null, recordingStarted: false}));
      //To set stop camera and microphone when initial render.
      if(localStream?.getVideoTracks()[0]){
        localStream.getVideoTracks()[0].enabled = false;
    }
    localStream?.getVideoTracks()[0]?.stop();
    if(localStream?.getAudioTracks()[0]){
        localStream.getAudioTracks()[0].enabled = false;
    }
    localStream?.getAudioTracks()[0]?.stop();
  },[]);
  
  useEffect(() => {
        const accessTokenInterval = setInterval(async () => {
            const wayOfLeft = localStorage.getItem("wayOfLeft");
            const isManualLeft = localStorage.getItem("isManualLeft");
            console.log("Liveclass wayOfLeft:", wayOfLeft, "isManualLeft:", isManualLeft);
            if(wayOfLeft && wayOfLeft === 'invalid' && isManualLeft !== 'yes') {
              try{
                const currentParticipantId = localStorage.getItem(meetService === JITSI ? "jitsiLocalParticipantId" : 'chimeLocalParticipantId');
                console.log("meetcomponent:", meetComponent, "currentSessionId:", currentSessionId, "selectedSubjectId:", selectedSubjectId, "selectedClassRoomId:", selectedClassRoomId, "currentParticipantId:", currentParticipantId);
                if (
                  meetComponent === "liveclass" &&
                  currentSessionId &&
                  selectedSubjectId &&
                  selectedClassRoomId &&
                  currentParticipantId
                ) {
                  deleteSessionParticipant({
                    variables: {
                      cId: selectedClassRoomId,
                      sId: currentSessionId,
                      sjId: selectedSubjectId,
                      participantId: currentParticipantId,
                    },
                  });
                }
              } catch(err) {
                console.log("Error deleting participant on invalid token:", err);
              } finally {
                localStorage.removeItem("isManualLeft");
                localStorage.removeItem("wayOfLeft");
              }
            }
        }, 1000);   
        if(meetService === JITSI) {
        localStorage.removeItem("isManualLeft");
        localStorage.removeItem("wayOfLeft");
        }
        
        return () => {
            clearInterval(accessTokenInterval);
        }
  }, [currentSessionId]);

  return (
    <div className='liveclassMainContainer'>
        <SubjectHeader 
          backgroundColor={state?.backGroundColor}
          setIsClickedSessionDetail = {setIsClickedSessionDetail} 
          singleSessionDetail={singleSessionDetail} 
          setSingleSessionDetail={setSingleSessionDetail} 
          headerName = {state?.title} 
          headerImage={state?.imageSrc} 
          backNavigation={{ path: role === TEACHER_ROLE ? PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH : PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH, state: state }} 
          showCreateScheduling={showCreateScheduling} 
          setShowCreateScheduling = {setShowCreateScheduling} 
          tabName={'liveclass'} 
          {...(clickedVideoUrl && { setClickedVideoUrl })}
        />
        {
          !clickedVideoUrl && loading &&  savedSessionLoading && <Loader bottom='130px'/>
        }
        {
          (!clickedVideoUrl) && ((!loading) && (!savedSessionLoading) && (!showCreateScheduling)) && ((totalCount && totalCount > 0) || (savedSessionsList?.totalCount && savedSessionsList?.totalCount > 0)) ?

          (
            <SessionsList 
              setEditClicked={setEditClicked}
              setClickedVideoUrl = {setClickedVideoUrl} 
              setClickedVideoData = {setClickedVideoData}
              savedSessionsList = {savedSessionsList} 
              setSingleSessionDetail={setSingleSessionDetail} 
              singleSessionDetail={singleSessionDetail} 
              upcomingSessionList = {liveSessionsList} 
              setShowCreateScheduling = {setShowCreateScheduling}
              setClickedSessionDetails={setClickedSessionDetails}
              clickedSessionDetails= {clickedSessionDetails}
              setIsDeleted={setIsDeleted}
              fetchUpcomingSessions={fetchUpcomingSessions}
              setIsClickedSessionDetail={setIsClickedSessionDetail}
              isClickedSessionDetail={isClickedSessionDetail}
              setIsTeacherButtonClicked= {setIsTeacherButtonClicked}
              isTeacherButtonClicked = {isTeacherButtonClicked}
              SetIsMoreClick = {SetIsMoreClick}
              sessionEnded = {sessionEnded}
              handleStartMeeting = {handleStartMeeting}
              handleJoinMeeting = {handleJoinMeeting}
              fetchSessionDetails = {fetchSessionDetails}
              setIsStudentButtonClicked = {setIsStudentButtonClicked}
              isStudentButtonClicked = {isStudentButtonClicked} 
              isMoreClick = {isMoreClick}
              setSessionEnded = {setSessionEnded}
              setIsStartingMeeting = {setIsStartingMeeting}
              isStartingMeeting = {isStartingMeeting}
            />
          )
          :
          ((!showCreateScheduling) && (totalCount === 0)) && (savedSessionsList?.totalCount === 0) && (!loading) && (!savedSessionLoading) && (!clickedVideoUrl) && <NoLiveSessions setShowCreateScheduling={setShowCreateScheduling} tabName='LiveClass' />
      }
      {
        (!clickedVideoUrl) && showCreateScheduling && (!loading) && (!savedSessionLoading) &&
        <div className='createScheduleMainContainer'>
          <CreateSchedule editClicked={editClicked} setEditClicked={setEditClicked} component={"liveclass"} setShowCreateScheduling={setShowCreateScheduling} clickedSessionDetails={clickedSessionDetails}/>
        </div>
      }
      {
        clickedVideoUrl && 
        <div className='detailView'>
          <video 
            src={clickedVideoUrl}
            ref={videoRef}
            onMouseOut={handleOnMouseOut} 
            autoPlay 
            disablePictureInPicture 
            controls 
            controlsList='nodownload noplaybackrate'
            loop
            className='detailVideoTagStyle' 
            style={{display: clickedExpandView ? 'none' : 'flex', outline: 'none', border: 'none', objectFit: 'contain', backgroundColor: '#3a3a3a'  }}
          />
        </div>
      }
      {
        clickedVideoUrl && <img alt="whiteCrossIcon" src={whiteCrossIcon} className={clickedExpandView ? 'expandCrossIcon' : 'whiteCrossIcon'} onClick={onClickCloseIcon}/>
      }   
      {
        clickedVideoUrl && <img alt="expandVideoIcon" src={expandVideoIcon} className='whiteExpandIcon' onClick={onClickExpandIcon}/>
      }     
      {
        clickedVideoUrl && clickedExpandView &&
        <ThemeProvider theme={theme}>
          <StyledDialog open={clickedExpandView} classes={{paper: 'VideoExpandPaperStyle'}}>
              <video src={clickedVideoUrl} autoPlay controls loop disablePictureInPicture controlsList='nodownload noplaybackrate' className='expandVideoTagStyle' style={{width: '100%', height: '100vh', outline: 'none', border: 'none', objectFit: 'contain', backgroundColor: '#3a3a3a' }}/>
          </StyledDialog>
        </ThemeProvider>
      }
    </div>
  )
}

export default LiveClass;
